import { render } from "./Facebook.vue?vue&type=template&id=56f3bfbe&scoped=true"
import script from "./Facebook.vue?vue&type=script&lang=js"
export * from "./Facebook.vue?vue&type=script&lang=js"

import "./Facebook.vue?vue&type=style&index=0&id=56f3bfbe&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56f3bfbe"]])

export default __exports__